import React from 'react';
import { BarcodeComponent } from 'utils/ScannerUtil';

interface BarcodeDisplayProps {
  sku: string;
  sizeInfo?: string;
  quantity?: number;
  extraInfo?: string;
}

const BarcodeDisplay: React.FC<BarcodeDisplayProps> = ({ sku, sizeInfo, quantity, extraInfo }) => {
  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <BarcodeComponent
        data={{
          sku,
          sizeInfo,
          quantity,
          extraInfo,
          
        }}
        options={{
          width: 2,
          height: 80,
          format: "CODE128",
          displayValue: true,
          fontSize: 14,
          margin: 5,
          background: '#ffffff',
        }}
      />
    </div>
  );
};

export default BarcodeDisplay; 